import React, { ReactElement } from 'react';

import { Icon as SidebarIcon } from '@iconify/react';

import router from '~/core/router';
import { sidebar } from '~/core/sidebar';
import { HomePageRoute } from '~/modules/home';
import { HomePageSidebarKey } from '~/modules/home/constants';
import analytics from '~/services/analytics';

router.addPrivateRoutes([HomePageRoute]);

sidebar.addItems({
  a: [
    {
      order: 1,
      key: HomePageSidebarKey,
      path: HomePageRoute.path,
      getTitle: HomePageRoute.getTitle,
      onClickCb: (): void => {
        analytics.trackEvent('side_menu_click', {
          button: 'home',
        });
      },
      Icon: ({ isActive }): ReactElement => {
        return (
          <SidebarIcon
            style={{ color: isActive ? '#fff' : '#000' }}
            icon="carbon:home"
          />
        );
      },
    },
  ],
});
